import * as React from "react";
import {Icon, Menu, MenuLabel, MenuList} from "bloomer";
import styled, {css} from "react-emotion";
import {Link} from "react-router-dom";

const MenuContainer = styled(Menu)`
  width: 350px;
  padding: 10px;

  @media (max-width: 768px) {
    width: 100%;
    border: 1px solid lightgrey;
  }
`;

const MLink = ({
  name,
  currentScreen,
  setScreen,
  children
}: {
  name: string;
  currentScreen: string;
  children: Array<string | JSX.Element>;
  setScreen(screen: string): void;
}) => {
  const active = css`
    background: #2f3241;
    color: white !important;
    :hover {
      background: #2f3241 !important;
    }
  `;

  const activate = () => {
    setScreen(name);
  };

  const className = name === currentScreen ? active : "";
  return (
    <Link to={name} className={className} onClick={activate}>
      {children}
    </Link>
  );
};

class DashboardMenu extends React.Component {
  public props: {
    screen: string;
    setScreen(screen: string): void;
  };

  public render() {
    const currentScreen = this.props.screen;
    const { setScreen } = this.props;
    return (
      <MenuContainer>
        <MenuLabel>Products</MenuLabel>
        <MenuList>
          <li>
            <MLink {...{ currentScreen, setScreen }} name="hedging">
              <Icon className="fa fa-eye" /> Hedging Tool
            </MLink>
          </li>
          <li>
            <MLink {...{ currentScreen, setScreen }} name="summarizer">
              <Icon className="fas fa-dollar-sign" /> Summarizer
            </MLink>
          </li>
          <li>
            <MLink {...{ currentScreen, setScreen }} name="exposure">
              <Icon className="fas fa-leaf" /> Exposure Analyzer
            </MLink>
          </li>
          <li>
            <MLink {...{ currentScreen, setScreen }} name="speech-recognition">
              <Icon className="fas fa-microphone" /> Speech Recognition
            </MLink>
          </li>
          <li>
            <MLink {...{ currentScreen, setScreen }} name="text-sentiment">
              <Icon className="far fa-comment-dots" /> Text Sentiment
            </MLink>
          </li>
          <li>
            <MLink {...{ currentScreen, setScreen }} name="cross-provider">
              <Icon className="fas fa-code-branch" /> Cross Provider
            </MLink>
          </li>
          <li>
            <MLink {...{ currentScreen, setScreen }} name="text-summarizer">
              <Icon className="fas fa-file-alt" /> Text Summarizer
            </MLink>
          </li>
          <li>
            <MLink {...{ currentScreen, setScreen }} name="face-restoration">
              <Icon className="far fa-smile" /> Face Restoration
            </MLink>
          </li>
          <li>
            <MLink {...{ currentScreen, setScreen }} name="translation">
              <Icon className="fas fa-globe" /> Translation
            </MLink>
          </li>
          <li>
            <MLink {...{ currentScreen, setScreen }} name="deepfake-detection">
              <Icon className="fab fa-youtube" /> DeepFake Detection
            </MLink>
          </li>
          <li>
            <MLink {...{ currentScreen, setScreen }} name="text2art">
              <Icon className="far fa-images" /> Art Generation
            </MLink>
          </li>
          <li>
            <MLink {...{ currentScreen, setScreen }} name="ner-extraction">
              <Icon className="fas fa-project-diagram" /> NER Model
            </MLink>
          </li>
          <li>
            <MLink {...{ currentScreen, setScreen }} name="question-answering">
              <Icon className="far fa-question-circle" /> Q/A Model
            </MLink>
          </li>
          <li>
            <MLink {...{ currentScreen, setScreen }} name="article-summarizer">
              <Icon className="far fa-newspaper" /> Article Summarizer
            </MLink>
          </li>
          <li>
            <MLink {...{ currentScreen, setScreen }} name="article-keywords">
              <Icon className="fas fa-newspaper" /> Article Keywords
            </MLink>
          </li>
          <li>
            <MLink {...{ currentScreen, setScreen }} name="video-to-text">
              <Icon className="fab fa-youtube" /> Video to Text
            </MLink>
          </li>
          <li>
            <MLink {...{ currentScreen, setScreen }} name="text-extraction">
              <Icon className="far fa-file-alt" /> Text Extraction
            </MLink>
          </li>
          <li>
            <MLink {...{ currentScreen, setScreen }} name="text-to-speech">
              <Icon className="far fa-file-audio" /> Text To Speech
            </MLink>
          </li>
          <li>
            <MLink {...{ currentScreen, setScreen }} name="text-generation">
              <Icon className="far fa-file-word" /> Text Generation
            </MLink>
          </li>
          <li>
            <MLink {...{ currentScreen, setScreen }} name="text-emotion">
              <Icon className="far fa-smile" /> Text Emotion
            </MLink>
          </li>
          <li>
            <MLink {...{ currentScreen, setScreen }} name="fear-and-greed-index">
              <Icon className="fas fa-chart-line" /> Fear & Greed Index
            </MLink>
          </li>
          <li>
            <MLink {...{ currentScreen, setScreen }} name="reddit-posts">
              <Icon className="fab fa-reddit" /> Reddit Posts
            </MLink>
          </li>
          <li>
            <MLink {...{ currentScreen, setScreen }} name="social-sentiment">
              <Icon className="far fa-thumbs-up" /> Social Sentiment
            </MLink>
          </li>
          <li>
            <MLink {...{ currentScreen, setScreen }} name="vision-ai">
              <Icon className="far fa-eye" /> Vision AI
            </MLink>
          </li>
          <li>
            <MLink {...{ currentScreen, setScreen }} name="paraphrasing-tool">
              <Icon className="fas fa-book" /> Paraphrasing Tool
            </MLink>
          </li>
          <li>
            <MLink {...{ currentScreen, setScreen }} name="text-similarity">
              <Icon className="fas fa-text-width" /> Text Similarity
            </MLink>
          </li>
          <li>
            <MLink {...{ currentScreen, setScreen }} name="face-detection">
              <Icon className="fas fa-user-friends" /> Face Detection
            </MLink>
          </li>
          <li>
            <MLink {...{ currentScreen, setScreen }} name="image-content">
              <Icon className="far fa-image" /> Image Content
            </MLink>
          </li>
          <li>
            <MLink {...{ currentScreen, setScreen }} name="face-similarity">
              <Icon className="far fa-meh" /> Face Similarity
            </MLink>
          </li>
          <li>
            <MLink {...{ currentScreen, setScreen }} name="grammar-checker">
              <Icon className="far fa-edit" /> Grammar Checker
            </MLink>
          </li>
          <li>
            <MLink {...{ currentScreen, setScreen }} name="jokes">
              <Icon className="far fa-comments" /> Geek Jokes
            </MLink>
          </li>
          <li>
            <MLink {...{ currentScreen, setScreen }} name="weather">
              <Icon className="far fa-sun" /> Weather
            </MLink>
          </li>
          <li>
            <MLink {...{ currentScreen, setScreen }} name="avatar">
              <Icon className="fas fa-user-astronaut" /> Avatar
            </MLink>
          </li>
          <li>
            <MLink {...{ currentScreen, setScreen }} name="image-labeling">
              <Icon className="far fa-images" /> Image Labeling
            </MLink>
          </li>
          <li>
            <MLink {...{ currentScreen, setScreen }} name="chatbot">
              <Icon className="fas fa-robot" /> Chatbot
            </MLink>
          </li>
          <li>
            <MLink {...{ currentScreen, setScreen }} name="meme-generator">
              <Icon className="far fa-id-badge" /> Meme Generator
            </MLink>
          </li>
          <li>
            <MLink {...{ currentScreen, setScreen }} name="trip-purpose">
              <Icon className="fas fa-plane" /> Trip Purpose
            </MLink>
          </li>
          <li>
            <MLink {...{ currentScreen, setScreen }} name="text-completion">
              <Icon className="far fa-file-alt" /> Text Completion
            </MLink>
          </li>
        </MenuList>
      </MenuContainer>
    );
  }
}

export default DashboardMenu;



// WEBPACK FOOTER //
// ./src/components/Menu/index.tsx